import React, { useEffect, useState } from "react";
import { Modal, message, ConfigProvider, Divider } from "antd";
import CustomInput from "../CustomInput";
import useUserStore from "../../stores/store";
import useScrollLock from "../../hooks/useScrollLock";

function AddFloorModal({ openModal, records }) {
  const { user, branches, restaurantId, restaurantName, setNetworkCall } = useUserStore();
  const [id, setId] = useState(records.id);
  const [name, setName] = useState(records.value);
  const [error, setError] = useState("");
  const [messageApi, contextHolder] = message.useMessage();

  // Lock scroll when modal is open
  useScrollLock(openModal);

  const clearFields = (defaultId = "", defaultName = "") => {
    setId(defaultId);
    setName(defaultName);
    setError("");
  };

  useEffect(() => {
    if (openModal) {
      clearFields(records.id || "", records.value || "");
    }
  }, [openModal]);

  const handleOk = async () => {
    const param = {
      id,
      name
    }
    records.onFinish({ showModal: false, param });
  };

  const handleCancel = () => {
    records.onCancel();
  };

  function onHandleFloorName(val) {
    if (val.length > 30) {
      message.warning("Floor name character limit exceeds. Please make it upto 30 characters.");
      return;
    }
    setName(val);
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        maskClosable={false}
        open={openModal}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        {contextHolder}
        <div className="flex flex-col font-uregular">
          <div className="text-2xl font-ubold">Add Floor Plan</div>
          <Divider />

          {error && <div className="w-full text-start mb-[8px] text-pink font-ubold">{error}</div>}
          {/* Name */}
          <CustomInput
            value={name}
            setValue={onHandleFloorName}
            showPadding={false}
            label="Floor Name"
            required={true}
            placeholder="e.g. Main Dinning"
            onPressEnter={handleOk}
          />

          <Divider />
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default AddFloorModal;
